import { http_app } from './HttpService.js'

export default {
	load(params = '') {
		return http_app.get('suggestions/pictures' + params)
	},
	save(data) {
		let copy_secret = process.env.VUE_APP_COPY_SECRET
		return http_app.put('suggestions/pictures/' + data.id, { keywords: data.keywords, copy_secret })
	},
	getCategories() {
		return http_app.get('suggestions/pictures/categories')
	}
}